import { useLoadingState } from "@/hooks/useLoadingState";
import { AnimatedLogo } from "@/components/ui/animated-logo";

interface LoadingIndicatorProps {
  message?: string;
}

// The one loading animation used everywhere in the app — route transitions,
// auth/coming-soon gates, and dashboard boot screens. Uses literal hex
// colors rather than CSS-var-driven classes so it renders identically
// regardless of whether an ancestor happens to be `.light`-scoped.
export function LoadingIndicator({ message = "Loading…" }: LoadingIndicatorProps) {
  return (
    <div className="flex flex-col items-center gap-4">
      <AnimatedLogo
        size="lg"
        animation="pulse"
        variant="svg"
        colorClassName="text-[#8B6BF0]"
      />
      <div className="relative h-1.5 w-64 overflow-hidden rounded-full bg-[#EFEFF7]">
        <div className="absolute inset-y-0 w-1/3 rounded-full bg-[#5A31D8] animate-loading-bar" />
      </div>
      <p className="font-archivo text-sm text-[#6E6B8A]">{message}</p>
    </div>
  );
}

interface LoadingScreenProps {
  message?: string;
}

export function LoadingScreen({ message = "Loading…" }: LoadingScreenProps) {
  useLoadingState({ isLoading: true });

  return (
    <div className="fixed inset-0 flex items-center justify-center min-h-screen bg-white">
      <LoadingIndicator message={message} />
    </div>
  );
}
